import { Component, OnInit } from "@angular/core";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { Router } from "@angular/router";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { DateFormateService } from "src/app/services/date-formate.service";
import { ApiConfiguration } from "src/app/services/http/api-configuration";
import { ApiService } from "src/app/services/http/api.service";
import { ToastClientService } from "src/app/services/toast/toast-client.service";
import { UploadZipService } from "src/app/services/upload-zip/upload-zip.service";
import { XlsxService } from "src/app/services/xlsx/xlsx.service";
import { ExportExcelService } from "src/app/shared/xlsx-view/export-excel.service";
import { XlsxViewComponent } from "src/app/shared/xlsx-view/xlsx-view.component";
import { ExcelModel } from "../shared/models/geography";
import { USER_PONITS_HEADER } from "../shared/models/mock-data";
import { RegionModel } from "../shared/models/region";
import { StateModel } from "../shared/models/state";
import { AdminDataProvider } from "../shared/providers/master-provider/admin-data.provider";
import { RegionProvider } from "../shared/providers/region.provider";
import { StateProvider } from "../shared/providers/state.provider";
import * as moment from 'moment';

@Component({
  selector: "app-user-points",
  templateUrl: "./user-points.component.html",
  styleUrls: ["./user-points.component.scss"],
})
export class UserPointsComponent implements OnInit {
  userPoints: any[];
  page = 1;
  getPaginationCount;
  excel: ExcelModel = new ExcelModel();
  filteredDetails: any = {
    search_string: "",
    module_id: [],
    states: [],
    city: [],
    regions: [],
    types: [],
    start_date: "",
    end_date: "",
  };
  filteredDetailsForApi: any = {
    search_string: "",
    module_id: "",
    states: "",
    city: "",
    regions: "",
    types: "",
    start_date: "",
    end_date: "",
  };
  resetFilteredDetailsForApi: any = {
    search_string: "",
    module_id: "",
    states: "",
    city: "",
    regions: "",
    types: "",
    start_date: "",
    end_date: "",
  };
  catogorys:any = [];
  category_name : any = [];
  sku_name : any = [];
  skuList:any = [];
  resetData: any[];
  resetDate: any;
  resetDropdown: boolean;
  regions: RegionModel[];
  states: StateModel[];
  modules: [];
  actionSuccess: boolean;
  addOrEditRegion: string;
  formGroup: FormGroup;
  submitted: boolean = false;
  tempOptionModel: any;
  selectedModule: number;
  selectedcategorySku: number;
  categorieId="";
  selectedDate="";
  slectedCategory="";
  slectedSku="";
  pointsType = [
    { id: 1, name: "King Service" },
    { id: 2, name: "Schemes" },
    { id: 3, name: "Visiblity" },
    { id: 4, name: "Tertiary Schemes" },
    { id: 5, name: "Content" },
    { id: 6, name: "Mystery Audit" },
    { id: 7, name: "Engagement" },
    { id: 8, name: "Rewards" },
    { id: 9, name: "Exceptions" },
  ];

  constructor(
    private apiService: ApiService,
    private apiConfig: ApiConfiguration,
    private fb: FormBuilder,
    private modalService: NgbModal,
    private toast: ToastClientService,
    private formateDate: DateFormateService,
    public stateProvider: StateProvider,
    public regionProviders: RegionProvider,
    private router: Router,
    public adminDataProvider: AdminDataProvider,
    public exportExcelService: ExportExcelService,
    private xlsx: XlsxService,
    private uploadFile: UploadZipService,
  ) {
    this.uploadFile.currentMessage.subscribe(message => {
      if (message.status == 'success') {
        this.getUserPoints(this.filteredDetailsForApi);
      }
    })
  }

  ngOnInit() {
    this.getUserPoints(this.filteredDetailsForApi);
    this.getAllModules();
    this.getCategory();
    this.getSKU();
  }

  ngDoCheck() {
    this.regions = this.regionProviders.regions;
    this.states = this.stateProvider.state;
  }

  getAllModules() {
    this.apiService.getHeaders(this.apiConfig.getModule).subscribe((res: any) => {
      this.modules = res.body.data;
    });
  }

  getCategory(){
    this.apiService.get(this.apiConfig.getAllCategiry).subscribe((res : any)=>{
      this.catogorys = res.data;
      this.catogorys.forEach(element => {
        this.category_name.push(element.brand_category_name)
      });
      console.log(res)
      
    })
  }
  getSKU(){
    this.apiService.get(this.apiConfig.getProductsList).subscribe((res : any)=>{
      this.skuList = res.data;
      this.catogorys.forEach(element => {
        this.sku_name.push(element.product_name)
      });
    })
  }
  get f() {
    return this.formGroup.controls;
  }

  getUserPoints(data) {
    this.apiService
      .getHeaders(
        this.apiConfig.getUserPoints +
        "?page=" +
        this.page +
        "&search_string=" +
        data.search_string +
        "&from_date=" +
        data.start_date +
        "&to_date=" +
        data.end_date +
        "&region_id=" +
        data.regions +
        "&module_id=" +
        data.module_id +
        "&state_code=" +
        data.states +
        "&city=" +
        data.city +
        "&type=" +
        data.types
      )
      .subscribe(
        (res: any) => {
          this.userPoints = res.body.data;
          console.log(res);
          this.getPaginationCount = res.headers.get("X-Pagination-Total-Count");
        },
        (err) => {
          console.log(err);
        }
      );
  }

  paginationClick(pageNumber) {
    this.page = pageNumber;
    this.getUserPoints(this.filteredDetailsForApi);
  }

  editUserPoints() { }

  deleteUserPoints() { }

  /*********************FILTER SECTIONS*****************************/
  /* Fillter section start */
  async selectedItem(data, serviceId) {
    switch (serviceId) {
      case 1: // roles
        this.filteredDetails.module_id = await data;
        break;
      case 2: // State
        this.filteredDetails.states = await data;
        break;
      case 3: // city
        this.filteredDetails.city = await data;
        break;
      case 4: // resions
        this.filteredDetails.regions = await data;
        break;
      case 5: // geography
        this.filteredDetails.types = await data;
        break;
      default:
        break;
    }
  }
  formateFillters(data, name) {
    if (data.status == "singleSelect") {
      this.filteredDetails[name].push(data.data.id);
      return this.filteredDetails[name];
    } else if (data.status == "singleDeselect") {
      this.filteredDetails[name].forEach((element, i) => {
        if (element == data.data.id) {
          this.filteredDetails[name].splice(i, 1);
        }
      });
      return this.filteredDetails[name];
    } else if (data.status == "SelectAll") {
      this.filteredDetails[name] = [];
      if (data.data) {
        data.data.forEach((element) => {
          this.filteredDetails[name].push(element.id);
        });
      }
      return this.filteredDetails[name];
    } else if (data.status == "unSelectAll") {
      this.filteredDetails[name] = [];
      return this.filteredDetails[name];
    }
  }
  filterListOfRecords() {
    try {
      this.filteredDetailsForApi.states = this.filteredDetails.states
        .map((i) => i.id)
        .join(",")
        .toString();
      this.filteredDetailsForApi.city = this.filteredDetails.city
        .map((i) => i.id)
        .join(",")
        .toString();
      this.filteredDetailsForApi.regions = this.filteredDetails.regions
        .map((i) => i.id)
        .join(",")
        .toString();
      this.filteredDetailsForApi.module_id = this.filteredDetails.module_id
        .map((i) => i.id)
        .join(",")
        .toString();
      this.filteredDetailsForApi.types = this.filteredDetails.types
        .map((i) => i.id)
        .join(",")
        .toString();
      this.filteredDetailsForApi.search_string = this.filteredDetails.search_string;
    } catch (error) { }
    console.log(this.filteredDetailsForApi);
    this.getUserPoints(this.filteredDetailsForApi);
  }

  selectedDates(dates) {
    if (dates.from) {
      this.filteredDetailsForApi.start_date = this.formateDate.formateDate(
        dates.from
      );
    }
    if (dates.to) {
      this.filteredDetailsForApi.end_date = this.formateDate.formateDate(
        dates.to
      );
    }
    if (!dates.from) {
      this.filteredDetailsForApi.start_date = "";
    }
    if (!dates.to) {
      this.filteredDetailsForApi.end_date = "";
    }
  }

  filterResetListOfRecords() {
    this.resetDropdown = true;
    this.resetData = [];
    this.resetDate = undefined;
    this.filteredDetails.search_string = "";
    this.filteredDetailsForApi = this.resetFilteredDetailsForApi;
    this.getUserPoints(this.filteredDetailsForApi);
  }

  showRegionModal(targetModal) {
    this.modalService.open(targetModal, {
      centered: true,
      backdrop: "static",
    });
  }

  addUserPoints(targetModal) {
    this.actionSuccess = false;
    this.addOrEditRegion = "add";

  this.formGroup = this.fb.group({
    user_id: new FormControl("", [Validators.required]),
    points: new FormControl("", [Validators.required]),
    points_type: new FormControl("", [Validators.required]),
    program_id: 1,
    points_mehtod: new FormControl("", [Validators.required]),
    description: new FormControl("", [Validators.required]),
    selected_sku: new FormControl(""),
    selected_category: new FormControl(""),
    month_year: new FormControl(""),
    category_sku: new FormControl("")
  });


    this.showRegionModal(targetModal);
  }

  onSubmitUserPoints(formData) {
    this.submitted = true;
    this.catogorys.forEach(element => {
      if(formData.selected_category == element.brand_category_name){
        this.categorieId = element.id
      }
    });
    if (this.formGroup.invalid) {
      return;
    }
    this.createUserPoint(formData);
  }

  errorMsg;
  
  createUserPoint(formData: any) {
    let payload = {
      user_id: formData.user_id,
      points: formData.points,
      points_type: formData.points_type,
      program_id: 1,
      points_mehtod: formData.points_mehtod,
      description: formData.description,
      userpoints_month: moment(formData.month_year).format("MM"),
      userpoints_year: moment(formData.month_year).format("YYYY"),
      sku_based: formData.category_sku,
      product_name:formData.selected_category,
      product_id: formData.selected_sku,
      category_id: this.categorieId
    }
    console.log(payload)
    this.errorMsg = '';
    let apiUrl = this.apiConfig.createUserPoints;
    this.apiService.post(apiUrl, formData).subscribe(
      (res: any) => {
        this.actionSuccess = true;
        this.getUserPoints(this.filteredDetailsForApi);
        this.toast.Success(res.body.data.message);
        this.modalService.dismissAll();
        this.formGroup.reset();
        this.submitted = false;
        this.selectedModule = null;
        this.selectedcategorySku = null;
      },
      (err) => {
        this.errorMsg = err;
        console.log(this.errorMsg);
        this.submitted = false;
      }
    );
  }

  resetForm() {
    this.submitted = false;
    this.formGroup.reset();
  }

  showuploadTemplateModal(targetModal) {
    this.tempOptionModel = this.modalService.open(targetModal, {
      centered: true,
      // backdrop: 'static'
    });
  }

  downloadExcel() {
    this.exportExcelService.exportUserPointExcel(this.pointsType,this.catogorys,this.skuList);
  }

  closeoptionModel() {
    this.tempOptionModel.close();
  }

  uploadXlsx(eve) {
    this.xlsx.uploadXlsx(eve).then((res) => {
      this.xlsxView(res);
    });
  }

  xlsxView(data) {
    data.apiHeaders = USER_PONITS_HEADER;
    this.closeoptionModel();
    let modalRef = this.modalService.open(XlsxViewComponent, {
      centered: true,
      backdrop: "static",
      size: "xl",
      scrollable: true,
      windowClass: "ExcelTemplateViewModal",
    });
    modalRef.componentInstance.xlsxDatas = data;
    modalRef.result.then(
      (result) => {
        console.log("XlsxViewComponent::", result);
        if (result.length > 0) {
          this.excel.excel_data = result;
          this.uploadMultiData(this.excel);
        }
      },
      (reason) => { }
    );
  }

  uploadMultiData(data) {
    console.log(data);
    let data1 = data.excel_data.filter(i => {
      if (i.Module == "Loyalty") {
        i.Module = 1;
      }
      if (i.Module == "Schemes") {
        i.Module = 2;
      }
      if (i.Module == "Visibility") {
        i.Module = 3;
      }
      if (i.Module == "Tertiary Schemes") {
        i.Module = 4;
      }
      if (i.Module == "Content") {
        i.Module = 5;
      }
      if (i.Module == "Mystery Audit") {
        i.Module = 6;
      }
      if (i.Module == "Engagement") {
        i.Module = 7;
      }
      if (i.Module == "Rewards") {
        i.Module = 8;
      }
      if (i.Module == "Exceptions") {
        i.Module = 9;
      }

      i["rocode"] = i["Outlet Code"];
      i["points"] = i["Points"];
      i["points_mehtod"] = i["Points Type"];
      i["points_type"] = i["Module"];
      i["description"] = i["Description"];
      delete i["Description"];
      delete i["Outlet Code"];
      delete i["Points"];
      delete i["Points Type"];
      delete i["Module"];
      delete i.isEdit;
    })
    console.log(data);
    let payload = {
      "userpointsdata": ""
    }
    payload.userpointsdata = (data.excel_data)
    this.enableUploadDiv(payload);
  }

  enableUploadDiv(data) {
    this.uploadFile.changeMessage({
      status: "upload",
      data: data,
      url: this.apiConfig.uploadUserPoints,
      module: "User points",
      zip: "no",
      excelname: "User ponits Excel",
    });
  }
  importAllUsers(data) {
    console.log(data);
    let data1 = data.excel_data.filter(i => {
      if (i.Module == "Loyalty") {
        i.Module = 1;
      }
      if (i.Module == "Schemes") {
        i.Module = 2;
      }
      if (i.Module == "Visibility") {
        i.Module = 3;
      }
      if (i.Module == "Tertiary Schemes") {
        i.Module = 4;
      }
      if (i.Module == "Content") {
        i.Module = 5;
      }
      if (i.Module == "Mystery Audit") {
        i.Module = 6;
      }
      if (i.Module == "Engagement") {
        i.Module = 7;
      }
      if (i.Module == "Rewards") {
        i.Module = 8;
      }
      if (i.Module == "Exceptions") {
        i.Module = 9;
      }
      delete i.isEdit;
    })
    console.log(data);
    // this.apiService.post(this.apiConfig.importExcelRegion, data).subscribe(
    //   (res: any) => {
    //     this.toast.Success("Data imported Successfully");
    //     this.regionProviders.getRegionList();
    //   },
    //   (err) => {
    //     this.toast.Error("Failed to Update");
    //     console.log(err);
    //   }
    // );
  }
  closeModel() {
    this.modalService.dismissAll();
    this.selectedModule = null;
    this.selectedcategorySku = null;
    this.formGroup.reset();
    this.submitted = false
  }
  vilidationFileds(id){
   console.log(id)
  }
}
